import { useMemo } from 'react';
import {
  DEFAULT_CHANNELS_BY_SERIALNUMBER,
  DEFAULT_EVENT_ON,
  SENSOR_F01,
  SETPOINT_I_S01,
} from '../../../../../service/controlUnit/util/constants';
import { CommanderAPI } from '../../../../../service/device/CommanderAPI/CommanderAPI';

const DEFAULT_CHANNELS = [SENSOR_F01, SETPOINT_I_S01, DEFAULT_EVENT_ON];

export const useGetDefaultChannels = (commanderId: string) => {
  const { data: commander, isLoading: isLoadingCommanderInfo } =
    CommanderAPI.useGetDeviceByIdQuery(commanderId ?? '', {
      skip: !commanderId || commanderId === '',
    });

  const defaultChannels = useMemo(() => {
    if (!commander?.articalNumber) return DEFAULT_CHANNELS;
    return (
      DEFAULT_CHANNELS_BY_SERIALNUMBER[commander?.articalNumber] ??
      DEFAULT_CHANNELS
    );
  }, [commander?.articalNumber]);

  return { data: defaultChannels, isLoading: isLoadingCommanderInfo };
};
